import { render } from "./ShowProject.vue?vue&type=template&id=17bdbe05&scoped=true&ts=true"
import script from "./ShowProject.vue?vue&type=script&lang=ts"
export * from "./ShowProject.vue?vue&type=script&lang=ts"

import "./ShowProject.vue?vue&type=style&index=0&id=17bdbe05&lang=scss"
import "./ShowProject.vue?vue&type=style&index=1&id=17bdbe05&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bdbe05"]])

export default __exports__